<header class="fixed-top bg-white">
	<div
		class="pt-2 pt-lg-3 redGradient position-relative"
		style="z-index: 2"
	></div>
	<nav
		class="d-lg-flex container-xxl bg-white position-relative"
		style="z-index: 1"
	>
		<h1 class="col-lg-2 p-0 m-0">
			<a
				class="hpLogo ms-5 ms-lg-0"
				[routerLink]="'/' + ClickarPath.PRIVATE"
			>
				@if (market) {
					@if (market === "ES") {
						<img
							style="width: 100px"
							[src]="wcmService.logoSpainUrl"
							alt="Homepage"
							title="Homepage"
						/>
					} @else {
						<img
							class="w-auto"
							[src]="wcmService.logoUrl"
							alt="Homepage"
							title="Homepage"
						/>
					}
				}
			</a>
		</h1>
		<div
			class="mainLinks col-lg-10 bg-white text-uppercase"
			appClickOutside
			[class.links-open]="hamburgerOpen"
			[detectAnchorOnly]="true"
			(clickOutside)="hamburgerOpen = false"
		>
			<button
				#hamburgerBtn
				class="hamburger position-absolute d-lg-none"
				[class.hamburger-open]="hamburgerOpen"
			>
				<!-- NOTE: used a render2 eventi instead of (touchstart) on #hamburgerBtn cause Capacitor delays it -->
				<span></span>
				<span></span>
				<span></span>
			</button>
			<ul class="d-flex flex-column flex-lg-row justify-content-end mt-5 mb-0 mt-lg-0 p-0">
				<li>
					<a
						class="px-4 px-lg-3 px-xl-4 menu-item"
						[routerLink]="'/' + ClickarPath.PRIVATE"
						routerLinkActive="activeLink"
						[routerLinkActiveOptions]="{ exact: true }"
						[class.activeLink]="isAuctionActive()"
					>
						<span class="lh-1">
							<span class="d-lg-inline-block align-lg-middle">
								{{ "menu.auctions" | translate }}
							</span>
						</span>
					</a>
				</li>
				@if (showcaseEnabled) {
					<li>
						<a
							class="px-4 px-lg-3 px-xl-4 menu-item"
							[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.SHOWCASE_MANAGEMENT + '/' + ClickarPath.SHOWCASE_CATALOGUE"
							routerLinkActive="activeLink"
							[routerLinkActiveOptions]="{ exact: true }"
						>
							<span class="lh-1">
								<span class="d-lg-inline-block align-lg-middle">
									{{ "menu.showcase" | translate }}
								</span>
							</span>
						</a>
					</li>
				}
				@if (user?.permission !== PERMISSION.VISITOR) {
					<li>
						<a
							class="px-4 px-lg-3 px-xl-4 menu-item pt-lg-2"
							[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.LIVE_FULL"
							routerLinkActive="activeLink"
							[routerLinkActiveOptions]="{ exact: true }"
						>
							<span class="btn-ico btn-ico-eye-before lh-1">
								<span class="d-lg-inline-block align-lg-middle">
									{{ "header.link.live" | translate }}
								</span>
							</span>
						</a>
					</li>
					@if (!isCustomerCenter) {
                        @if (market !== "IT") {
                            <li>
                                <a
                                        class="px-4 px-lg-3 px-xl-4 menu-item"
                                        [routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.PURCHASE_SUMMARY"
                                        routerLinkActive="activeLink"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                >
								<span class="lh-1">
									<span class="d-lg-inline-block align-lg-middle">
										{{ "menu.purchaseSummary" | translate }}
									</span>
								</span>
                                </a>
                            </li>
                        }
                        @else {
                            <li>
                                <a
                                        [title]="'menu.purchaseSummary' | translate"
                                        aria-haspopup="true"
                                        aria-expanded="purchaseOpen"
                                        class="px-4 px-lg-3 px-xl-4 menu-item text-start cursor-pointer"
                                        [class.activeLink]="purchaseOpen"
                                        (click)="$event.stopPropagation(); openMenu('purchase')"
                                >
                                        <!-- TEXT -->
                                        <span class="text-uppercase">
                                            {{ "menu.purchaseSummary" | translate }}
                                        </span>

                                        <!-- DESKTOP ARROW -->
                                        <span
                                                class="accordion-arrow d-none d-lg-inline-block"
                                                [class.accordion-open]="purchaseOpen"
                                        >
                                            <span></span>
                                        </span>

                                        <!-- MOBILE ARROW -->
                                        <span class="simple-arrow simple-arrow-tiny d-inline-block d-lg-none align-middle"></span>
                                </a>

                                @if (purchaseOpen) {
                                    <section
                                            class="sub-menu d-flex flex-column flex-lg-row"
                                            style="right: auto"
                                            appClickOutside
                                            (clickOutside)="closeMenus()"
                                            animate.enter="open-menu"
                                            animate.leave="close-menu"
                                    >
                                        <!-- Mobile back -->
                                        <button
                                                (click)="closeMenus()"
                                                class="text-uppercase d-lg-none text-start"
                                        >
                                            <span class="simple-arrow simple-arrow-left d-inline-block align-middle"></span>
                                            {{ "menu.goBack" | translate }}
                                        </button>


                                        <article>
                                            <ul>
                                                <li>
                                                    <a
                                                            class="ps-5 pe-3 text-capitalize"
                                                            (click)="closeMenus()"
                                                            [routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.PURCHASE_SUMMARY"
                                                    >
                                                        {{ "shoppingCart.title" | translate }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                            class="ps-5 pe-3 text-capitalize"
                                                            (click)="closeMenus()"
                                                            [routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.POST_SALES"
                                                    >
                                                        {{ "support.postBuy.title" | translate }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </article>
                                    </section>
                                }
                            </li>
                        }
					}
					@if (user) {
						<li class="d-lg-none">
							<a
								class="px-4 menu-item"
								[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.USER_PROFILE"
							>
								<span>{{ "menu.showProfile" | translate }}</span>
							</a>
						</li>
					}
				}
				@if (user) {
					<li class="d-lg-none">
						<a
							class="px-4 menu-item"
							href="#"
							(click)="logout()"
						>
							<span>
								{{ "user.logout" | translate }}
							</span>
						</a>
					</li>
				}
				<li>
					<div class="langContainer text-center py-2 py-lg-0 ps-4 ps-lg-3 pe-2 lineBefore">
						<mat-select
							[(value)]="currentLang"
							(selectionChange)="changeLang($event.value)"
							class="text-uppercase text-start"
						>
							<!-- placeholder="choose custom label" -->
							<mat-select-trigger>
								@let cLang = currentLang.slice(0, 2);
								<span
									class="text-uppercase before-ico"
									[ngClass]="'ico-flag-' + cLang"
								>
									{{ cLang }}
								</span>
							</mat-select-trigger>
							@for (l of langs; track l) {
								@let lang = l.slice(0, 2);
								<mat-option [value]="l">
									<span
										class="text-uppercase before-ico"
										[ngClass]="'ico-flag-' + lang"
									>
										{{ lang }}
									</span>
								</mat-option>
							}
						</mat-select>
					</div>
				</li>
				@if (user) {
					<li class="d-none d-lg-flex position-relative ps-2">
						<button
							aria-haspopup="true"
							aria-expanded="profileOpen"
							class="profileButton ps-2 menu-item text-start pe-0 lineBefore text-blue"
							(click)="$event.stopPropagation(); openMenu('profile')"
						>
							<span class="profile-avatar text-uppercase">
								{{ user.name.at(0) }}
								{{ user.surname.at(0) }}
							</span>
							<span class="profile-name">
								<span class="profile-greetings">{{ "user.welcome" | translate }}</span>
								<br />
								<span class="d-none d-xl-inline">{{ user?.name }} </span>{{ user?.surname }}
							</span>
						</button>

						@if (profileOpen) {
							<section
								class="sub-menu d-flex flex-column flex-lg-row"
								appClickOutside
								(clickOutside)="closeMenus()"
								animate.enter="open-menu"
								animate.leave="close-menu"
							>
								<button
									(click)="closeMenus()"
									class="text-uppercase d-lg-none text-start"
								>
									<span class="simple-arrow simple-arrow-left d-inline-block align-middle"> </span>
									{{ "menu.goBack" | translate }}
								</button>
								<ul>
									@if (isAdmin || isCustomerCenter) {
										<li>
											<a
												class="ps-5 pe-3 text-capitalize"
												[routerLink]="'/' + ClickarPath.ADMIN"
											>
												{{ "header.link.adminPanel" | translate }}
											</a>
										</li>
									}
									<li>
										<a
											class="ps-5 pe-3 text-capitalize"
											[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.USER_PROFILE"
										>
											{{ "user.personalData" | translate }}
										</a>
									</li>
									<li>
										<a
											class="ps-5 pe-3 text-capitalize"
											href="#"
											(click)="logout()"
										>
											{{ "user.logout" | translate }}
										</a>
									</li>
								</ul>
							</section>
						}
					</li>
				}
				@if (!environment.mobile && (isAdmin || hasPermission("LOADER") || hasPermission("AUCTIONEER") || hasPermission("EXHIBITOR"))) {
					<li>
						<button
							[title]="'menu.management' | translate"
							aria-haspopup="true"
							aria-expanded="managementOpen"
							class="px-4 px-lg-3 px-xl-4 menu-item text-start"
							[class.activeLink]="managementOpen"
							(click)="$event.stopPropagation(); openMenu('management')"
						>
							<span class="btn-ico btn-ico-gear-before">
								<span class="d-lg-none text-uppercase">{{ "menu.management" | translate }}</span>
								<span
									class="accordion-arrow d-none d-lg-inline-block"
									[class.accordion-open]="managementOpen"
								>
									<span> </span>
								</span>
								<span class="simple-arrow simple-arrow-tiny d-inline-block d-lg-none align-middle"> </span>
							</span>
						</button>
						@if (managementOpen) {
							<section
								class="sub-menu d-flex flex-column flex-lg-row"
								appClickOutside
								(clickOutside)="closeMenus()"
								animate.enter="open-menu"
								animate.leave="close-menu"
							>
								<button
									(click)="closeMenus()"
									class="text-uppercase d-lg-none text-start"
								>
									<span class="simple-arrow simple-arrow-left d-inline-block align-middle"> </span>
									{{ "menu.goBack" | translate }}
								</button>
								<h2 class="text-capitalize px-3 mt-4 d-lg-none">
									{{ "menu.management" | translate }}
								</h2>

								@if (isAdmin || hasPermission("AUCTIONEER")) {
									<article>
										<h3 class="menu-title ps-4 ps-lg-3 pe-3 pt-4 mb-0 no-wrap">
											<span>
												{{ "menu.auctionManagement" | translate }}
											</span>
										</h3>
										<ul>
											<li>
												<a
													class="ps-5 pe-3 text-capitalize"
													[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.AUCTION_MANAGEMENT + '/' + ClickarPath.TEMPLATE"
												>
													{{ "template.title" | translate }}
												</a>
											</li>
											<li>
												<a
													class="ps-5 pe-3 text-capitalize"
													[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.AUCTION_MANAGEMENT + '/' + ClickarPath.CREATE_TEMPLATE"
												>
													{{ "template.create" | translate }}
												</a>
											</li>
											@if (isAdmin || (hasPermission("AUCTIONEER") && user.flgAuctioneer)) {
												<li>
													<a
														class="ps-5 pe-3 text-capitalize"
														[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.AUCTION_MANAGEMENT + '/' + ClickarPath.CREATE_AUCTION"
													>
														{{ "auction.create" | translate }}
													</a>
												</li>
											}
											<li>
												<a
													class="ps-5 pe-3 text-capitalize"
													[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.AUCTION_MANAGEMENT + '/' + ClickarPath.AUCTION"
												>
													{{ "auction.auctions.title" | translate }}
												</a>
											</li>
										</ul>
									</article>
								}
								<article>
									<h3 class="menu-title ps-4 ps-lg-3 pe-3 pt-4 mb-0 no-wrap">
										<span>
											{{ "menu.vehicleManagement" | translate }}
										</span>
									</h3>
									<ul>
										@if (isAdmin || hasPermission("AUCTIONEER") || hasPermission("LOADER")) {
											<li>
												<a
													class="ps-5 pe-3 text-capitalize"
													[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.VEHICLE_MANAGEMENT + '/' + ClickarPath.UPLOAD_VEHICLE"
												>
													{{ "vehicle.upload" | translate }}
												</a>
											</li>
											<li>
												<a
													class="ps-5 pe-3 text-capitalize"
													[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.VEHICLE_MANAGEMENT + '/' + ClickarPath.VEHICLE_LIST"
												>
													{{ "vehicle.list" | translate }}
												</a>
											</li>
										}
									</ul>
								</article>
								@if (isAdmin || hasPermission("AUCTIONEER") || hasPermission("EXHIBITOR")) {
									<article>
										<h3 class="menu-title ps-4 ps-lg-3 pe-3 pt-4 mb-0 no-wrap">
											<span>
												{{ "menu.showcaseManagement" | translate }}
											</span>
										</h3>
										<ul>
											<li>
												<a
													class="ps-5 pe-3 text-capitalize"
													[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.SHOWCASE_MANAGEMENT"
												>
													{{ "menu.showcaseManagement" | translate }}
												</a>
											</li>
											<li>
												<a
													class="ps-5 pe-3 text-capitalize"
													[routerLink]="'/' + ClickarPath.PRIVATE + '/' + ClickarPath.SHOWCASE_MANAGEMENT + '/' + ClickarPath.SHOWCASE_SOLD"
												>
													{{ "vehicle.sold" | translate }}
												</a>
											</li>
										</ul>
									</article>
								}
							</section>
						}
					</li>
				}
			</ul>
		</div>
	</nav>
</header>
